export const GET_PRODUCT_TEMPLATE_SUCCESS = 'GET_PRODUCT_TEMPLATE_SUCCESS';
